import { Routes } from '@angular/router';
import { authenticatedRouteGuards, canActivateUser } from '@shared/guard/guard';
import { PageKey } from '@shared/services/page/models/page.key';

export const jobPositionRoute: Routes = [
  {
    path: 'job-positions',
    loadComponent: () => import('@job-position/pages/list/list.component').then(m => m.ListComponent),
    canActivate: [...authenticatedRouteGuards, canActivateUser],
    data: {
      title: 'Cargos',
      key: PageKey.JOB_POSITIONS
    }
  }
];
